export default __webpack_public_path__ + "static/media/gloryforkorn--og--imprint.66a3a02e.jpg";